import { UPDATE_TIMEZONE, oidcActionTypes } from './types'



export function updateTimezone(value: string): oidcActionTypes {
    return {
        type: UPDATE_TIMEZONE,
        payload: value
    };
}